import cs from 'classnames';
import styles from './styles.module.scss';

export const getUserStatusStyle = (enabled: boolean) =>
    cs(
        styles['statusInfo'],
        enabled ? styles['statusActive'] : styles['statusInActive']
    );
